import { sortBy } from "async";
import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({
	PanelTitle: {
		k: "article.header.title",
		v: "Articles"
	},

	PanelDescription: {
		k: "article.header.desc",
		v: "List of Articles"
	},

	NoResults: {
		k: "article.noResults",
		v: "No results. please try again with different parameters"
	},

	NotFoundTitle: {
		k: "article.notfound.title",
		v: "Article Not Found"
	},

	NotFoundDescription: {
		k: "article.notfound.description",
		v: ""
	},

	NotFoundAction: {
		k: "article.notfound.action",
		v: "Back to Catalog"
	},

	ViewDetails: {
		k: "article.viewDetails",
		v: "Open"
	},

	ResultMeta: {
		k: "article.resultMeta",
		v: "Showing ${start} - ${end} of ${total} results", // Showing 10 of 54 results
		argNames: ["start", "end", "total"]
	},

	ResultMetaLoading: {
		k: "article.resultMetaLoading",
		v: "Loading ${start} - ${end}", // Showing 10 of 54 results
		argNames: ["start", "end", "count"]
	},

	SortBy: {
		k: "article.sortBy",
		v: "Sort By"
	},

	MoreInfo: {
		k: "article.moreInfo",
		v: "More Info"
	}
});



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/Kb.labels.ts